module.exports = __webpack_public_path__ + "static/promote-financial-education-desktop.d1638677.webp";